import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchFederalReconciliationsTypes = getApiActionTypes('FETCH_FEDERAL_RECONCILIATIONS');
export const createFederalReconciliationsNoteTypes = getApiActionTypes(
  'ADD_FEDERAL_RECONCILIATIONS_NOTE',
);
export const FEDERAL_RECONCILIATIONS_SELECT_ACCOUNT_GROUP =
  'FEDERAL_RECONCILIATIONS_SELECT_ACCOUNT_GROUP';
